(function() {

	/**
	 * @type BasketButtons
	 */
	var BasketButtons = (/** @constructor */ function () {

		/** @type {Object} параметры */
		var opt = {
			slideOutDuration : 350
		};

		var objectHash = {},
			$buttons;

		/**
		 * Обработка нажатия
		 * @private
		 */
		function clickHandler(e) {
			e.preventDefault();
			var $t = $(this);
			if (!$t.hasClass('load')) {
				$t.addClass('load');
				var params = {},
				id = $t.data('product-id'),
				$input = $('input.quantity'),
				count = 1;
				if($input.length > 0)
					count = parseInt($input.val());
				var $button = objectHash[id];
				if($button){
					if($button.data("inp")){
						count = $button.data("inp").val();
					}
				}

				Order.add(id, count, addResponseHandler, params);
			}
		}

		/**
		 * Обработка ответа сервера о добавлении
		 * @param {Object} data данные
		 * @private
		 */
		function addResponseHandler(data) {
			$buttons.removeClass('load');
			if ((data) && (data.item)) {

				$('.add-to-basket[data-product-id="'+data.item.id+'"]').addClass('added').html('добавлено');

				var $button = objectHash[data.item.id];
				if ($button) {
					if(($button)&&($button.data("inp"))){
						$button.data("inp").val(1);
					}
/*
					var inb = $button.data("inp").parent().find(".in-basket");
					if(inb.length>0){
						window.clearTimeout();
						inb.stop().remove();
					}
*/
/*
					$(document.createElement('div'))
						.addClass('in-basket')
						.html('Товар добавлен в корзину')
						.hide()
						.insertAfter($button.data("inp").parent())
						.slideDown(opt.slideOutDuration,function(){
							var $this = $(this);
							window.setTimeout(function(){ $this.remove() }, 1000);
						});
*/
				}
			}
		}


		/**
		 * Обработка ответа сервера о получении параметров
		 * @param {Object} data данные
		 * @private
		 */
		function initParams(data,id){
			if((data)&&(objectHash[id])&&(objectHash[id].data('p'))){
				var p = new ProductParams(objectHash[id],objectHash[id].data("p"),data);
				objectHash[id].data("p_params",p);
			}
		}

		return {
			/**
			 * Инициализация
			 * @memberOf BasketButtons
			 * @param {Object} [options] параметры
			 */
			init : function(options) {
				$.extend(opt, options);
				$buttons = $(opt.selector);
				$buttons.click(clickHandler);
				for (var i = 0; i < $buttons.length; i++) {
					BasketButtons.register($buttons.eq(i));

					var inp = $buttons.eq(i).parent().find(".count input");
					if(inp.length>0){
						inp.inputArrowCounter();
						$buttons.eq(i).data("inp",inp);
					}
				}
			},
			register: function(button){
				var id = button.data('productId');
				if(objectHash[id] === undefined){
					objectHash[id] = button;


				}
			}
		};

	})();

	Order.BasketButtons = BasketButtons;

	var ProductParams = function(parent,$dom,data){
		this.parent = parent;
		this.$dom = $dom;

		this.response = { bc: '',
						  of: '',
						  cyl: '',
						  axis: ''};
		this.steps = new Array();
		this.isEmpty = false;
		this.isToric = false;

		this.init(data);
	}

	ProductParams.prototype = {
		init: function(data){
			var self = this;
			self.bc = data.bc;
			self.of = data.of;
			self.cyl = data.cyl;
			self.axis = data.axis;
			self.formula = data.formula;
			if((self.cyl.length>0)&&(self.axis.length>0)){
				self.isToric = true;
			}
			if(self.bc.length>0){
				var $p = $(document.createElement("div"))
								.addClass("b-p");
				$(document.createElement("div"))
								.addClass("b-label")
								.text("Базовая кривизна")
								.appendTo($p);
				self.bcDom = $(document.createElement("select"))
									.change(function(){ self.bcChange() })
									.appendTo($p);
				for(var i=0;i<self.bc.length;i++){
					for(var j=0;j<self.bc[i].val.length;j++){
						$(document.createElement("option"))
								.attr({ value: self.bc[i].val[j] })
								.text(self.bc[i].val[j])
								.appendTo(self.bcDom);
					}
				}
				$p.appendTo(self.$dom);


				$p = $(document.createElement("div"))
								.addClass("b-p");

				var txt = (self.isToric)?"Сфера":"Оптическая сила";

				$(document.createElement("div"))
								.addClass("b-label")
								.text(txt)
								.appendTo($p);
				self.ofDom = $(document.createElement("select"))
									.change(function(){ self.ofChange() })
									.appendTo($p);
				$p.appendTo(self.$dom);


				if(self.isToric){
					$p = $(document.createElement("div"))
									.addClass("b-p");


					$(document.createElement("div"))
									.addClass("b-label")
									.text("Цилиндр")
									.appendTo($p);
					self.cylDom = $(document.createElement("select"))
										.change(function(){ self.cylChange(); })
										.appendTo($p);
					$p.appendTo(self.$dom);


					$p = $(document.createElement("div"))
									.addClass("b-p");

					$(document.createElement("div"))
									.addClass("b-label")
									.text("Ось")
									.appendTo($p);
					self.axisDom = $(document.createElement("select"))
										.appendTo($p);
					$p.appendTo(self.$dom);
				}

				self.bcChange();
			}else{
				self.isEmpty = true;
			}
		},

		bcChange: function(){
			var self = this;
			self.handleChange(0,self.bcDom,self.ofDom,self.bc,self.of);
			self.ofChange();
		},

		ofChange: function(){
			var self = this;
			self.handleChange(1,self.ofDom,self.cylDom,self.of,self.cyl);
			if(self.isToric){
			   self.cylChange();
			}

		},

		cylChange: function(){
			var self = this;
			self.handleChange(2,self.cylDom,self.axisDom,self.cyl,self.axis);
		},


		/**
		 * Реакция зависимого селекта на изменении в управляющем селекте
		 * @param {Number} level уровень за который отвечает управляющий селект
		 * @param {JQuery object} $subj_dom управляющий селект
		 * @param {JQuery object} $obj_dom зависимый селект
		 * @param {array} subj_arr массив значений для управляющего селекта
		 * @param {array} obj_arr массив значений для зависимого селекта
		 */

		handleChange: function(level,$subj_dom,$obj_dom,subj_array,obj_array){
			var self = this;

			var subj = self._findByVal(subj_array,$subj_dom.val());
			self.steps.splice(level,self.steps.length-1);
			if(level==0){
				self.steps = [];
			}
			self.steps.push(subj.id);
			if(!((level==1)&&(!self.isToric))){
				var res = self._checkFormula(self.steps,level,self.formula);
				var tmp = [];
				$obj_dom.empty();
				var next_level = level+1;
				var construct_array = new Array();
				for(var i=0;i<res.length;i++){
					if(tmp.indexOf(res[i][next_level])<0){
						var idx = res[i][next_level];
						var obj = self._findById(obj_array,idx);
						for(var j=0;j<obj.val.length;j++){
							if(construct_array.indexOf(obj.val[j])<0){
								construct_array.push(obj.val[j]);
							}
						}
						tmp.push(res[i][next_level]);
					}
				}

				function sIncrease(i, ii){
					if (parseFloat(i) > parseFloat(ii))
						return 1;
					else if (parseFloat(i) < parseFloat(ii))
						return -1;
					else
						return 0;
				}
				construct_array = construct_array.sort(sIncrease);

				for(var i=0;i<construct_array.length;i++){
					$(document.createElement("option"))
									.attr({ value: construct_array[i] })
									.text(construct_array[i])
									.appendTo($obj_dom);
				}
			}
		},

		/**
		 * Проверка формулы (поиск возможных путей по графу)
		 * @param {Array} steps уже пройденные узлы графа
		 * @param {Number} level уровень до которого необходимо дойти
		 * @param {array} next список всех возможных путей с данной точки
		 */
		_checkFormula: function(steps,level,next){
			var self = this;
			var res = new Array();

			for(var i=0;i<self.formula.length;i++){
				if(self.formula[i][level]==steps[level]){
					res.push(self.formula[i]);
				}
			}
			if((steps.length-1)>level){
				res = self._checkFormula(self.steps,level+1,res);
			}

			return res;
		},

		/**
		 * Получение массиков по коду
		 * @param {Array} array Список массивов
		 * @param {Number} idx значение кода
		 */
		_findById: function(array,idx){
			var self = this;
			var item = null;
			for(var i=0;i<array.length;i++){
				if(array[i].id==idx){
				   item = array[i];
				   break;
				}
			}
			return item;
		},

		/**
		 * Получение массивов по значению
		 * @param {Array} array Список массивов
		 * @param {Number} val значение
		 */
		_findByVal: function(array,val){
			var self = this;
			var item = null;
			for(var i=0;i<array.length;i++){
				for(var j=0;j<array[i].val.length;j++){
					if(array[i].val[j]==val){
					   item = array[i];
					   break;
					}
				}
			}
			return item;
		}
	}

})();